<template>
  <div
    class="provider-card pt-4 pb-3 px-2 md:py-4 md:px-6 rounded text-sm md:text-base text-black-high-emphasis"
    :class="{
      'border-gray-divider box-border border-2 bg-white-high-emphasis': content.isPlusProvider,
      'bg-gray-light': !content.isPlusProvider
    }"
  >
    <p class="text-base text-gray-darkest md:font-bold">
      {{ content.networkText }}
    </p>
    <p class="leading-normal">
      {{ content.savingsText }}
    </p>
    <p class="leading-normal" data-testid="savings-value">
      ${{ savingsValue }}
    </p>
    <div
      class="flex items-center gap-2 text-base md:text-xl font-bold text-gray-darkest"
      :style="style"
    >
      <div
        v-if="content.isPlusProvider"
        class="provider-card__icon"
        v-dompurify-html:svg="iconSource"
      />
      {{ content.providerText }}
    </div>
    <p class="tracking-0.5px font-bold leading-normal">
      {{ content.memberCostText }}
    </p>
    <p
      class="font-bold leading-normal text-gray-darkest"
      :style="style"
      data-testid="member-cost-value"
    >
      ${{ memberCostValue }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import ProviderCard from '@/model/ProviderCard'
import useRemoteIcon from '@/hooks/useRemoteIcon'
import { useFlow } from '@/store'

export default defineComponent({
  props: {
    content: {
      type: Object as () => ProviderCard,
      required: true,
      validator: (value: ProviderCard) => value instanceof ProviderCard
    }
  },
  setup (props) {
    const { pricingSummary: pricing } = useFlow()
    const memberCostValue = props.content.isPlusProvider ? pricing.totalMoop : pricing.totalMoopNonPlus
    const savingsValue = props.content.isPlusProvider ? pricing.saving : pricing.savingNonPlus
    const iconSource = props.content.plusProviderIcon?.isIcon && props.content.plusProviderIcon.source
      ? useRemoteIcon(props.content.plusProviderIcon.source)
      : null
    const style = computed(() => {
      const isPlusProvider = props.content.isPlusProvider
      return isPlusProvider ? { color: props.content.plusColor } : {}
    })

    return {
      memberCostValue,
      savingsValue,
      iconSource,
      style
    }
  }
})
</script>

<style>
.provider-card {
  display: grid;
  grid-template-columns: 1.3fr 1fr min-content;
  grid-template-rows: 1fr 1fr;
  grid-gap: 4px 16px;

  &__icon svg {
    @apply h-3 w-5 fill-current flex-shrink-0
  }
}

@screen md {
  .provider-card {
    grid-template-columns: 1fr  0.6fr min-content;
    grid-gap: 2px 16px;

    &__icon svg {
      @apply h-4 w-6;
    }
  }
}
</style>
